import { ChainID } from '@ankr.com/chains-list';

import { ChainSelectorsProvider } from 'modules/chains/components/ChainSelectorsProvider';
import { fallbackChain } from 'modules/chains/constants';
import { useChain } from 'modules/chains/components/ChainsSelectWithContext/ChainProvider';

interface SelectorsProviderProps {
  children: React.ReactNode;
}

export const StatsChainSelectorsProvider = ({
  children,
}: SelectorsProviderProps) => {
  const { chain = fallbackChain } = useChain();

  const isFlare = chain.id === ChainID.FLARE;
  const isPolkadot = chain.id === ChainID.POLKADOT;
  const isTac = chain.id === ChainID.TAC;
  const isZkVerify = chain.id === ChainID.ZKVERIFY;

  return (
    <ChainSelectorsProvider
      chain={chain}
      shouldExpandMainnets={isZkVerify || isPolkadot}
      shouldExpandTestnets={isFlare || isZkVerify || isTac}
      shouldMergeTendermintGroups
      shouldMergeTonGroups
    >
      {children}
    </ChainSelectorsProvider>
  );
};
